import { common, getIdentityUid } from '@/common';
import { storage } from '@/utils/storage';

const STORAGE_KEY = 'float_entry_position';
const EDGE_PADDING = 8;

export interface FloatEntryPosition {
  left: number;
  top: number;
}

function scopeKey(): string {
  const uid = getIdentityUid() || 'anonymous';
  const tenant = common.tenantCode?.trim() || 'default';
  return `${STORAGE_KEY}:${tenant}:${uid}`;
}

export function getFloatEntryPosition(): FloatEntryPosition | null {
  return storage.get<FloatEntryPosition>(scopeKey());
}

export function saveFloatEntryPosition(position: FloatEntryPosition): void {
  storage.set(scopeKey(), position);
}

export function clampFloatEntryPosition(
  element: HTMLElement,
  position: FloatEntryPosition,
): FloatEntryPosition {
  const rect = element.getBoundingClientRect();
  const maxLeft = Math.max(EDGE_PADDING, window.innerWidth - rect.width - EDGE_PADDING);
  const maxTop = Math.max(EDGE_PADDING, window.innerHeight - rect.height - EDGE_PADDING);

  return {
    left: Math.min(Math.max(position.left, EDGE_PADDING), maxLeft),
    top: Math.min(Math.max(position.top, EDGE_PADDING), maxTop),
  };
}
